<template>
  <div class="top_box">
    <div class="banner">
      <div class="title">{{ returnData.title }}</div>
      <div class="line"></div>
      <div class="content">{{ returnData.subtitle }}</div>
      <img v-if="returnData.thumbUrl" :src="returnData.thumbUrl" alt="" />
    </div>
    <div class="main_box">
      <div class="menu_box">
        <div class="left_menu">
          <div class="left_title">
            <div class="title1">集团概览</div>
            <div class="title2">ABOUT US</div>
          </div>
          <div class="left_item">
            <div
              class="item"
              v-for="(item, index) in menuList"
              :key="'item' + index"
              :class="{ choose: item.key === chooseKey }"
              @click="changeItem(item.key)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="right_article">
          <groupOverviewIntro
            :returnData="returnData"
            v-if="chooseKey === 1"
          ></groupOverviewIntro>
          <managementTeam v-else-if="chooseKey === 2"></managementTeam>
          <framework v-else-if="chooseKey === 3"></framework>
          <groupGlory v-else-if="chooseKey === 4"></groupGlory>
          <developHistory v-else-if="chooseKey === 5"></developHistory>
          <bigEvents v-else-if="chooseKey === 6"></bigEvents>
        </div>
      </div>
    </div>
    <img
      v-if="chooseKey === 6"
      class="top_png"
      src="@/assets/text/bigEv_bg.png"
      alt=""
    />
  </div>
</template>
<script setup>
import { ref, watch, onMounted } from "vue";
import api from "@/api/api";
import groupOverviewIntro from "./components/groupOverviewIntro.vue";
import managementTeam from "./components/managementTeam.vue";
import framework from "./components/framework.vue";
import groupGlory from "./components/groupGlory.vue";
import developHistory from "./components/developHistory.vue";
import bigEvents from "./components/bigEvents.vue";
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();
let chooseKey = ref(1);
let returnData = ref({});
let menuList = ref([
  {
    name: "集团简介",
    key: 1,
  },
  {
    name: "领导班子",
    key: 2,
  },
  {
    name: "组织架构",
    key: 3,
  },
  {
    name: "集团荣誉",
    key: 4,
  },
]);
const changeItem = (key) => {
  // chooseKey.value = key;
  router.push({
    query: {
      chooseKey: key,
    },
  });
};
const getBanner = async () => {
  let res = await api.getPageConfigDetail(74);
  if (res.code === "0") {
    returnData.value = res.res.data;
    // console.log()
  }
};
getBanner();
watch(
  () => route,
  (newval) => {
    if (newval && newval.query.chooseKey) {
      chooseKey.value = newval.query.chooseKey * 1;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  },
  { deep: true, immediate: true }
);
</script>
<style lang="less" scoped>
.top_box {
  width: 100%;
  .banner {
    width: 100%;
    height: 427px;
    position: relative;
    .title {
      position: absolute;
      left: 170px;
      top: 120px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #ffffff;
    }
    .line {
      position: absolute;
      left: 170px;
      top: 223px;
      width: 60px;
      height: 2px;
      background: rgba(255, 255, 255, 0.4);
    }
    .content {
      position: absolute;
      left: 170px;
      top: 254px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #ffffff;
    }
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: -1;
    }
  }
  .main_box {
    width: 100%;
    padding: 42px 8.33vw;
    box-sizing: border-box;
    position: relative;
    .menu_box {
      display: flex;
      .left_menu {
        height: auto;
        min-height: 222px;
        width: 180px;
        background: #f0f0f0;
        margin-right: 63px;
        z-index: 3;
        .left_title {
          width: 100%;
          height: 74px;
          background: #006ab1;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: center;
          .title1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
            margin-right: 17px;
          }
          .title2 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            margin-right: 17px;
            margin-top: 4px;
          }
        }
        .left_item {
          .item {
            cursor: pointer;
            text-align: right;
            height: 37px;
            line-height: 37px;
            padding-right: 17px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
          }
          .choose {
            background: #223e62 !important;
            color: #ffffff !important;
          }
        }
      }
      .right_article {
        z-index: 2;
        position: relative;
        width: calc(100% - 243px);
      }
    }
  }
  .top_png {
    width: 100%;
    height: 526px;
    position: absolute;
    top: 534px;
    z-index: -2;
  }
}
</style>